export default __webpack_public_path__ + "static/media/Clear_Btn.56c0b77a.svg";